import { useParams, Link } from 'react-router-dom';
import { useMemo } from 'react';
import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MovieCard from '@/components/base/MovieCard';
import { movies, categories } from '@/mocks/movies';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = useMemo(
    () => categories.find((c) => c.slug === slug),
    [slug]
  );

  const categoryMovies = useMemo(
    () => movies.filter((m) => m.categorySlug === slug),
    [slug]
  );

  if (!currentCategory) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="container-site pt-24 pb-16 text-center">
          <h1 className="text-2xl font-heading font-bold text-foreground-800 mb-4">分类不存在</h1>
          <Link to="/" className="btn-primary cursor-pointer">返回首页</Link>
        </div>
        <Footer />
      </div>
    );
  }

  const pageTitle = `${currentCategory.name} - 高清免费在线观看 | 6080影院`;
  const pageDesc = `6080影院${currentCategory.name}频道，汇集海量${currentCategory.name}高清资源，免费在线观看，播放流畅不卡顿，高清在线影院级画质。`;

  return (
    <>
      <ScrollToTop />
      <SEO
        title={pageTitle}
        description={pageDesc}
        keywords={`${currentCategory.name},高清电影免费看,免费电视剧全集,6080影院,在线观看`}
        canonicalUrl={`https://www.6080cinema.com/category/${slug}`}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="pt-20 pb-8 bg-background-100">
            <div className="container-site">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: currentCategory.name },
                ]}
              />
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/10 flex items-center justify-center">
                  <i className={`${currentCategory.icon} text-primary-500 text-lg`}></i>
                </div>
                <div>
                  <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    {currentCategory.name}
                  </h1>
                  <p className="text-sm text-foreground-500 mt-0.5">
                    共{categoryMovies.length}部影片
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="py-4 bg-background-100 border-b border-background-200 overflow-x-auto">
            <div className="container-site">
              <div className="flex items-center gap-2 min-w-max">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-all duration-200 ${
                      cat.slug === slug
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-200 text-foreground-600 hover:bg-background-300 hover:text-foreground-800'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="py-10 md:py-14">
            <div className="container-site">
              {categoryMovies.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
                  {categoryMovies.map((movie) => (
                    <MovieCard key={movie.id} movie={movie} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-200 flex items-center justify-center">
                    <i className="ri-film-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">暂无该分类的影片</p>
                </div>
              )}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}